import IMake, { Make } from './IMake';
import IModel, { Model } from './IModel';
import IState, { State } from './IState';

class Utility {

  public static _buildQueryParams(incomingArray: string[], paramName: string, paramValues: string[] | number[]): string[] {
    let outgoingArray: string[] = [];
    if (paramValues && paramValues.length > 0) {
      let separator: string = (incomingArray.length === 0) ? '?' : '&';
      for (let i = 0; i < paramValues.length; i++) {
        for (let j = 0; j < incomingArray.length; j++) {
          let entry: string = incomingArray[j] + separator + paramName + "=" + paramValues[i];
          outgoingArray.push(entry);
        }
      }
      return outgoingArray;
    } else {
      return incomingArray;
    }
  }

  public static createDataFromCampaign(entry: any): any {
    let stateObj: Array<IState> = [];
    if (entry?.states) {
      stateObj = entry?.states.map((state: string) => {
        const container: IState = new State(state);
        return container;
      });
    }

    let makes: Array<IMake> = [];
    for (let key in entry.makeIds) {
      if (entry.makeIds.hasOwnProperty(key)) {
        const value = entry.makeIds[key];
        const make: IMake = new Make(false, value, 0, key, -1);
        makes.push(make);
      }
    }
    let models: Array<IModel> = [];
    for (let key in entry.modelIds) {
      if (entry.modelIds.hasOwnProperty(key)) {
        const value = entry.modelIds[key];
        const model: IModel = new Model(value, key);
        models.push(model);
      }
    }

    const data: any = {
      'messageBody': entry.messageBody,
      'title': entry.title,
      'url': entry.url,
      'id': entry.id,
      'makes': makes.map((obj: IMake) => obj.Name).join(', '),
      'models': models.map((obj: IModel) => obj.Name).join(', '),
      'years': entry.modelYears?.map((yr: number) => yr.toString()).join(', '),
      'modelFloorPlans': entry.modelFloorPlans?.join(', '),
      'states': stateObj?.map((obj) => obj.name).join(', '),
      'zipCodes': entry.zipCodes?.join(', '),
      'registeredAfterDate': entry.registeredAfterDate,
      'registeredBeforeDate': entry.registeredBeforeDate,
      'submittingUser': entry.submittingUser,
      'createdDateTime': entry.createdDateTime,
      'submittedDateTime': entry.submittedDateTime,
      'scheduledDateTime': entry.scheduledDateTime,
      'status': entry.status,
      'geoFenceCity': entry.geoFenceCity,
      'geoFenceStreetAddress': entry.geoFenceStreetAddress,
      'geoFenceState': entry.geoFenceState,
      'geoFenceZipCode': entry.geoFenceZipCode,
      'geoFenceRadiusInMiles': entry.geoFenceRadiusInMiles,
      'geoFenceLatitude': entry.geoFenceLatitude,
      'geoFenceLongitude': entry.geoFenceLongitude,
      'vinTargetsOriginalFileName': entry.vinTargetsOriginalFileName,
      'vinTargetsClaimCheckIdentifier': entry.vinTargetsClaimCheckIdentifier,
      'vinTargetsDescription': entry.vinTargetsDescription,
      'bypassUserNotificationOptOut': entry.bypassUserNotificationOptOut
    }

    return data;
  }
}

export default Utility;